import keyMirror from 'keymirror';

const MEAL_PREFS = keyMirror({
  BBML: null,
  BLML: null,
  CHML: null,
  DBML: null,
  FPML: null,
  GFML: null,
  KSML: null,
  LCML: null,
  LFML: null,
  LSML: null,
  NLML: null,
  NSML: null,
  SFML: null,
  VGML: null,
  VLML: null,
});

export default MEAL_PREFS;
